/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";

import { OldProgressBarQuestionnaireContainer } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireContainer";

import { HealthSurveillanceQuestionnaireProps } from "../models";
import { CompletedDate } from "../../components/CompletedDate";
import { QuestionnaireTypes } from "../../questionnaires/model";

import { HealthSurveillanceDeclarationSection } from "./HealthSurveillanceDeclarationSection";
import { HealthSurveillanceConfidentialitySection } from "./HealthSurveillanceConfidentialitySection";
import { HealthSurveillancePersonalDetailsSection } from "./HealthSurveillancePersonalDetailsSection";
import { HealthSurveillanceMedicalQuestionsSection } from "./HealthSurveillanceMedicalQuestionsSection";
import { HealthSurveillanceMedicalQuestionsSectionTwo } from "./HealthSurveillanceMedicalQuestionsSectionTwo";
import { HealthSurveillanceWorkingConfinedSpacesSection } from "./HealthSurveillanceWorkingConfinedSpacesSection";
import { HealthSurveillanceNightWorkerSection } from "./HealthSurveillanceNightWorkerSection";
import { HealthSurveillanceFoodHandlerSection } from "./HealthSurveillanceFoodHandlerSection";
import { HealthSurveillanceSkinSection } from "./HealthSurveillanceSkinSection";
import { HealthSurveillanceSkinSectionTwo } from "./HealthSurveillanceSkinSectionTwo";
import { HealthSurveillanceAudiometrySection } from "./HealthSurveillanceAudiometrySection";
import { HealthSurveillanceRespiratorySection } from "./HealthSurveillanceRespiratorySection";
import { HealthSurveillanceHavsSection } from "./HealthSurveillanceHavsSection";
import { HealthSurveillanceIonisingRadiationSection } from "./HealthSurveillanceIonisingRadiationSection";
import { HealthSurveillanceManualHandlingMSKQuestionnaireSection } from "./HealthSurveillanceManualHandlingMSKQuestionnaireSection";
import { HealthSurveillancePitPupQuestionnaireSection } from "./HealthSurveillancePitPupQuestionnaireSection";
import { HealthSurveillanceLAAWorkerSection } from "./HealthSurveillanceLAAWorkerSection";
import { HealthSurveillanceFieldForceSection } from "./HealthSurveillanceFieldForceSection";

export const HealthSurveillanceQuestionnaireKey = "HealthSurveillance";

const loadQuestionnaire = (): void => null;

/**
 * @deprecated Replaced with HealthSurveillanceQuestionnaire
 */
export const OldHealthSurveillanceQuestionnaire: React.FunctionComponent<HealthSurveillanceQuestionnaireProps> = (props: HealthSurveillanceQuestionnaireProps) => {
    return (
        <>
            <CompletedDate readonly={props.readonly} task={props.task} />
            <OldProgressBarQuestionnaireContainer
                readonly={props.readonly}
                loadQuestionnaire={loadQuestionnaire}
                submitQuestionnaire={props.submitQuestionnaire}
                questionnaireKey={HealthSurveillanceQuestionnaireKey}
                questionnaireType={QuestionnaireTypes.Other}
            >
                <HealthSurveillanceConfidentialitySection questionConfigs={props.questionConfigs} />
                <HealthSurveillancePersonalDetailsSection
                    questionConfigs={props.questionConfigs}
                    getOrgLevels={props.getOrgLevels}
                    autoFill={props.autoFill}
                    employeeRecord={props.employeeRecord} />
                <HealthSurveillanceMedicalQuestionsSection questionConfigs={props.questionConfigs} recordMedicalsSeparately={props.recordMedicalsSeparately} />
                {!props.removeMedicalSections &&
                    <HealthSurveillanceMedicalQuestionsSectionTwo
                        questionConfigs={props.questionConfigs}
                        fileUploadApi={props.fileUploadApi}
                        onFileUpload={props.onFileUpload}
                        onDeleteFile={props.onDeleteFile}
                        getDownloadLink={props.getDownloadLink}
                    />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceWorkingConfinedSpacesSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceNightWorkerSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceFoodHandlerSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceSkinSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceSkinSectionTwo questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceAudiometrySection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceRespiratorySection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceHavsSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections  &&
                    <HealthSurveillanceIonisingRadiationSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceManualHandlingMSKQuestionnaireSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillancePitPupQuestionnaireSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceLAAWorkerSection questionConfigs={props.questionConfigs} />
                }
                {!props.removeMedicalSections &&
                    <HealthSurveillanceFieldForceSection questionConfigs={props.questionConfigs} />
                }
                <HealthSurveillanceDeclarationSection questionConfigs={props.questionConfigs} />
            </OldProgressBarQuestionnaireContainer>
        </>
    );
};
